import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';

const ViewNonTeachingStaff = () => {
  const { id } = useParams();
  const [staff, setStaff] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchStaff = async () => {
      try {
        const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getNonTeachingStaffById/${id}`);
        setStaff(response.data);
        setLoading(false);
      } catch (err) {
        setError(err.message);
        setLoading(false);
      }
    };

    fetchStaff();
  }, [id]);

  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error}</div>;

  const excludedKeys = ['_id', '__v', 'password', 'createdAt', 'updatedAt', 'profilePicture'];

  return (
    <div className="container mx-auto p-6 bg-white shadow-lg rounded-lg">
      <h1 className="text-3xl font-bold mb-6 text-center">Non-Teaching Staff Profile</h1>
      <hr />
      <br />
      <div className="flex flex-col md:flex-row">
        {staff?.profilePicture && (
          <div className="flex-shrink-0 mb-4 md:mb-0 md:mr-6">
            <img
              src={staff.profilePicture}
              alt="Profile"
              className="rounded-lg shadow-lg w-32 h-32 object-cover"
            />
          </div>
        )}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          {Object.keys(staff)
            .filter((key) => !excludedKeys.includes(key))
            .map((key) => (
              <div key={key} className="bg-gray-100 p-4 rounded-lg shadow-md">
                <strong className="block text-gray-700">
                  {key.charAt(0).toUpperCase() + key.slice(1).replace(/([A-Z])/g, ' $1')}:
                </strong>
                <div className="text-gray-900">
                  {key === 'dob' || key === 'joiningDate'
                    ? new Date(staff[key]).toLocaleDateString()
                    : staff[key]}
                </div>
              </div>
            ))}
        </div>
      </div>
    </div>
  );
};

export default ViewNonTeachingStaff;
